export default __webpack_public_path__ + "static/media/phone.603b0fe6.svg";